export default __webpack_public_path__ + "static/media/career-choice.bdb09ae0.svg";